export const  mobileZh = {
  MobileInstructions: '手机监考说明',
  mobileDesc: '本场考试已开启手机监考，请打开手机微信或QQ扫码连接手机摄像头。',
  mobileDesc1: '',
  Cautions: '注意事项',
  mobileCheck: {
    Battery: '检查电量',
    Internet: '检查网络',
    RunningApps: '关闭后台应用'
  },
  tipsConcat: {
    one: '1、扫码后请【允许】手机摄像头授权，并按指引完成手机监考流程',
    two: '2、若手机监考断连，可通过电脑端的【求助】-【监考二维码】进行重连'
  },
  connected: '已连接',
  bloomAiDetection001: '手机监考画面AI检测',
  bloomAiDetection002: '头部',
  bloomAiDetection003: '双手',
  bloomAiDetection004: '部分大腿',
  bloomAiDetection005: '电脑屏幕',
  bloomAiDetection006: '请按照参考示例调整手机监考画面，确保距离',
  bloomAiDetection007: '1.5-2米',
  bloomAiDetection008: '，画面中需要包含',
  bloomAiDetection009: '头部、双手、部分大腿',
  bloomAiDetection0010: '。调整好后进行AI检测（每15秒可检测一次）。若你已按照要求摆放，可跳过此步骤。',
  bloomAiDetection0011: '跳过',
  bloomAiDetection0012: '开始检测',
  bloomAiDetection0013: '参考示例',
  bloomAiDetection0014: '你的画面'
}
export const  mobileEn = {
  MobileInstructions: 'Mobile Proctoring Instructions',
  mobileDesc: 'Mobile proctoring has been enabled for this exam.',
  mobileDesc1: 'Please open WeChat or QQ to scan the QR code to connect to the camera of your mobile phone.',
  Cautions: 'Cautions',
  mobileCheck: {
    Battery: 'Battery Check',
    Internet: 'Internet Check',
    RunningApps: 'Close All Running Apps'
  },
  tipsConcat: {
    one: '1. After scanning the code, please [Allow] the authorization of mobile phone camera, and go through the invigilation process with instructions.',
    two: '2. If your phone disconnected, you can rescan the code from [Help] - [proctoring QR code] on the computer.'
  },
  connected: 'connected',
  bloomAiDetection001: 'AI detection of mobile phone invigilation',
  bloomAiDetection002: 'Head',
  bloomAiDetection003: 'Hands',
  bloomAiDetection004: 'Part of the thigh',
  bloomAiDetection005: 'Computer screen',
  bloomAiDetection006: 'Please adjust the mobile phone invigilation screen according to the reference example, ensuring it is',
  bloomAiDetection007: ' 1.5 to 2 meters',
  bloomAiDetection008: ' away from the camera. The screen should include',
  bloomAiDetection009: ' the head, both hands, part of the thighs',
  bloomAiDetection0010: '. After adjustment, you can start the detection (once every 15 seconds). If you have already arranged as required, you can skip this step.',
  bloomAiDetection0011: 'Skip',
  bloomAiDetection0012: 'Start the detection',
  bloomAiDetection0013: 'Reference example',
  bloomAiDetection0014: 'Your view'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/mobile.js